module.exports = __webpack_public_path__ + "img/logo.4ff41cbd.png";